import React, { useEffect, useState } from "react";
import { Bot } from "lucide-react";
import { api } from "../lib/api";
import { getLastStatus, subscribeAiStatus } from "../lib/aiStatus";

const AI_STATE = {
  ACTIVE: { color: "#2E7D46", bg: "#F1FAF3", dot: "#2E7D46" },
  FALLBACK: { color: "#B7891B", bg: "#FBF6E7", dot: "#B7891B" },
  UNAVAILABLE: { color: "#8A7788", bg: "#F4F1EE", dot: "#B0A6B8" },
};

// Indicador do estado da IA explicativa. Busca a fonte oficial no mount e
// se atualiza imediatamente (sem refresh) quando o teste OpenAI e disparado.
export default function AIStatusIndicator({ compact = false }) {
  const [s, setS] = useState(() => getLastStatus());

  useEffect(() => {
    // Se ja existe resultado de teste na sessao, reflete de imediato; senao busca a fonte oficial.
    if (!getLastStatus()) {
      api.get("/credit/ai/status")
        .then(({ data }) => {
          if (getLastStatus()) return;
          const lat = data.state === "ACTIVE" ? data.last_call?.latency_ms : null;
          setS({ ...data, latency_ms: lat });
        })
        .catch(() => { if (!getLastStatus()) setS(null); });
    }
    return subscribeAiStatus(setS);
  }, []);

  if (!s) return null;
  const st = AI_STATE[s.state] || AI_STATE.UNAVAILABLE;
  const isFallbackish = s.state !== "ACTIVE";
  const latency = s.state === "ACTIVE" && s.latency_ms != null ? `${s.latency_ms} ms` : null;

  return (
    <div
      className={`flex items-center justify-between gap-3 rounded-xl border px-4 py-2.5 transition-colors duration-300 ${compact ? "mt-3" : "mb-4"}`}
      style={{ background: st.bg, borderColor: st.dot + "44" }}
      data-testid="credit-ai-status"
    >
      <div className="flex items-center gap-2.5">
        <span className="grid h-6 w-6 place-items-center rounded-lg text-white" style={{ background: st.color }}><Bot size={13} /></span>
        <div className="flex items-center gap-2">
          <span className="h-2 w-2 rounded-full" style={{ background: st.dot }} />
          <span className="text-[13px] font-bold" style={{ color: st.color }} data-testid="ai-status-label">
            {s.label}{latency ? <span className="font-semibold"> · <span data-testid="ai-status-latency">{latency}</span></span> : null}
          </span>
        </div>
      </div>
      <span
        className={`${isFallbackish ? "text-[10px] font-normal" : "text-[11px]"} text-[#8A7788]`}
        data-testid="ai-status-message"
      >
        {s.message}
      </span>
    </div>
  );
}
